import { clsx } from "clsx";
import { useContext } from "react";
import { LobbySettingsContext } from "../../../entities";
import { getCategoryImageSrc } from "../../lib";

interface IExternalIconProps {
  id: string | number;
  className?: string;
}

export function ExternalIcon({ id, className }: IExternalIconProps) {
  const { theme } = useContext(LobbySettingsContext);

  return (
    <div
      style={{
        mask: `url(${getCategoryImageSrc(theme, id)}) center / contain no-repeat`,
      }}
      className={clsx("external-icon", className)}
    />
  );
}
